<!--  FOOTER LINKS  -->

<div class="written-content padded">
	<p class="footer-links">
		<a
			[routerLink]="['/configure/terms-of-use']"
			class="text-hl"
			data-element-click="legal_link__engage_configure_footer__[Terms of use]"
			[routerLinkActive]="'active'"
		>
			Terms of use
		</a>
		|
		<a
			[routerLink]="['/configure/privacy-policy']"
			class="text-hl"
			data-element-click="legal_link__engage_configure_footer__[Privacy Policy]"
			[routerLinkActive]="'active'"
		>
			Privacy Policy
		</a>
		|
		<a
			[routerLink]="['/configure/cookie-policy']"
			class="text-hl"
			data-element-click="legal_link__engage_configure_footer__[Cookie Policy]"
			[routerLinkActive]="'active'"
		>
			Cookie Policy
		</a>
	</p>
</div>

<!--  END FOOTER LINKS  -->
